import React, { useState, useEffect } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PreviewIcon from '@mui/icons-material/Visibility';
import CommonModal from 'components/commonModal/commonModal'
import { getPlacardPreview } from 'services/PlacardService';

function PlacardModal({ open, handleClose, tripId, text }) {
  const [isLoading, setIsLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  async function getPlacard() {
    try {
      setIsLoading(true);
      // If tripId exists, use it, otherwise use text
      const payload = tripId ? { tripId } : { text };
      const result = await getPlacardPreview(payload);
      if (result.success) {
        setPreviewImage(result.imageUrl);
      }
    } catch (error) {
      console.error('Preview failed:', error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (tripId || text) {
      getPlacard();
    }
  }, [tripId, text]);

  const handleDownload = () => {
    if (previewImage) {
      const link = document.createElement('a');
      link.href = previewImage;
      // Use appropriate name based on source
      const fileName = tripId ? `placard_${tripId}.svg` : 'placard_preview.svg';
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <CommonModal open={open} handleClose={handleClose}>
      <Box sx={{ 
        // width: '400px',
        padding: '20px'
      }}>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          gap: 1,
          mb: 3
        }}>
            <Button
              startIcon={<CloudDownloadIcon />}
              onClick={handleDownload}
              variant="contained"
              color="primary"
              size="small"
            >
              Download
            </Button>
        </Box>
        
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
            <CircularProgress size={24} />
          </Box>
        ) : previewImage ? (
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <img
              src={previewImage}
              alt="Placard Preview"
              style={{ 
                maxWidth: '100%', 
                maxHeight: '300px',
                objectFit: 'contain'
              }}
            />
          </Box>
        ) : (
          <Typography 
            sx={{ 
              textAlign: 'center',
              color: '#666',
              fontSize: '14px'
            }}
          >
            Click preview to view the placard
          </Typography>
        )}
      </Box>
    </CommonModal>
  );
}

export default PlacardModal;